import React from 'react'
import ffffff from '../image/ffffff.avif'
import { styled } from '@mui/system'
import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import Typography from '@mui/material/Typography'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'

const useStyles = styled((theme) => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
}))
function ARVR_FAQ_page() {
  return (
    <div>
      <div className="mt-5">
        <div className="container pt-3">
          <div className="text-center Curriculum_Main_text">
            <div className="">
              <h2 className="display-6">Frequently Asked Questions</h2>
              <p className="pt-2">
                Our Responses to Your Inquiries: Unblocking the Way to Clarity
              </p>
            </div>
          </div>
          <div className="row">
            <div className="col-md-5">
              <div className="FAQ_img">
                <img
                  src={ffffff}
                  onContextMenu={(e) => e.preventDefault()}
                ></img>
              </div>
            </div>
            <div className="col-md-7 pt-5 d-none d-md-block">
              <div className="pt-5">
                <div className="pt-5">
                  <div className="pt-5">
                    <ARVR_FAQ />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-12 d-sm-block d-md-none mb-5">
              <ARVR_FAQ />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

function ARVR_FAQ() {
  const classes = useStyles()
  const [expanded, setExpanded] = React.useState(false)

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false)
  }
  return (
    <>
      <div className={classes.root}>
        <Accordion
          className="py-2"
          expanded={expanded === 'panel1'}
          onChange={handleChange('panel1')}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1bh-content"
            id="panel1bh-header"
            className="FAQ_background_color"
          >
            <Typography style={{ fontSize: '1.2rem' }}>
              What is AR/VR technology and why is it gaining so much attention globally?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
             AR overlays digital content onto the real world, while VR immerses users in a fully virtual environment. These technologies are transforming industries like gaming, education, healthcare, and manufacturing.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          className="py-2"
          expanded={expanded === 'panel2'}
          onChange={handleChange('panel2')}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel2bh-content"
            id="panel2bh-header"
            className="FAQ_background_color"
          >
            <Typography style={{ fontSize: '1.2rem' }}>
              
           Why is AR/VR important in today’s world?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
             Because AR/VR is transforming industries like education, healthcare, gaming, e-commerce, training, and real estate, creating massive career opportunities.
            </Typography>
          </AccordionDetails>
        </Accordion>
        {/* <Accordion
          className="py-2"
          expanded={expanded === 'panel3'}
          onChange={handleChange('panel3')}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel3bh-content"
            id="panel3bh-header"
            className="FAQ_background_color"
          >
            <Typography style={{ fontSize: '1.2rem' }}>
              What skills will I learn during the program?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              You will gain expertise in 3D modeling, Unity/Unreal Engine development, AR/VR application design, computer vision basics, and immersive experience creation.
            </Typography>
          </AccordionDetails>
        </Accordion> */}
        <Accordion
          className="py-2"
          expanded={expanded === 'panel4'}
          onChange={handleChange('panel4')}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel4bh-content"
            id="panel4bh-header"
            className="FAQ_background_color"
          >
            <Typography style={{ fontSize: '1.2rem' }}>
              What skills will I learn in this program?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              There are various skills in AR/VR, including:
              <ul>
                <li>Unity & Unreal Engine</li>
                <li>ARCore & ARKit Development</li>
                <li>Vuforia & Mixed Reality Toolkit</li>
                <li>
                  3D Modeling & Simulation & XR Application Development
                </li>
              </ul>
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          className="py-2"
          expanded={expanded === 'panel5'}
          onChange={handleChange('panel5')}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel5bh-content"
            id="panel5bh-header"
            className="FAQ_background_color"
          >
            <Typography style={{ fontSize: '1.2rem' }}>
              How will this program help my career?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
            This AR/VR Internship Program equips you with hands-on experience, industry-relevant skills, and real-world projects that employers value.
             You will gain expertise in tools like Unity, Unreal Engine, ARCore, ARKit, and 3D modeling; build a strong portfolio to showcase in interviews; and earn an industry-recognized certificate to enhance your resume and LinkedIn profile.
              The program also opens doors to diverse career opportunities in gaming, healthcare, education, e-commerce, real estate, and more—while providing career guidance and mentorship to help you stand out in a competitive job market.
            </Typography>
          </AccordionDetails>
        </Accordion>
      </div>
    </>
  )
}
export default ARVR_FAQ_page
